import * as React from 'react';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface FinalCTAProps {
  loginUrl: string;
  whatsappUrl: string;
}

export function FinalCTA({}: FinalCTAProps) {
  return (
    <section className="edu-final-cta">
      <style>{`
        .edu-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .edu-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .edu-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .edu-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .edu-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        @media (max-width: 640px) {
          .edu-final-cta {
            padding: 60px 24px;
          }
          .edu-final-cta h2 {
            font-size: 24px;
          }
          .edu-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .edu-final-ctas a {
            justify-content: center;
          }
        }
      `}</style>
      <div className="edu-final-inner">
        <h2>Dale a tu comedor el proveedor que merece.</h2>
        <p>Empezá a recibir frutas y verduras frescas con la calidad y puntualidad que tu institución necesita.</p>
        <div className="edu-final-ctas">
          <a href={route('wholesale.pricing')} className="edu-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="edu-btn-secondary" onClick={() => trackSignupClicked('educacion', 'footer')}>
            <i className="fa fa-user-plus" /> Crear una cuenta
          </a>
        </div>
      </div>
    </section>
  );
}
